/**
 * 新房源提示(个新房源您还没有看过)
 * 
 * @Author: Focci
 * @Date: 2023-07-20 14:41:54
 * @Last Modified by: Focci
 * @Last Modified time: 2023-07-20 14:41:54
 */

import Link from 'next/link'
import SVGBack from '@img/back.svg'
import clsx from 'clsx'
import CircularProgress from '@mui/material/CircularProgress'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'
import { useLocale, useTranslations } from 'next-intl'
import { useEffect, useRef, useState } from 'react'
import { isFunction } from 'lodash-es'
import { fetchGet, fetchProxy } from '@lib/fetch/client'
import { urls } from '@lib/parse'
import { ButtonBase } from '@comp/material'

export function TipsForNewListingsWithCount({
  searchParam,
  apiParam,
}) {
  const { checkListTime } = searchParam
  const controller = useRef()

  // const locale = useLocale()
  const ts = useTranslations('search')
  const [count, setCount] = useState(0)
  const [loading, setLoading] = useState(!!checkListTime)

  useEffect(() => {
    if(checkListTime) {
      controller.current = new AbortController()
      const { signal } = controller.current
      const param = { ...apiParam, dataType: 2, listTime: checkListTime }
      
      fetchProxy(
        fetchGet('houses', param, { signal }).then((res) => {
          setCount(res.count)
        }),
        setLoading
      )
    }

    return () => {
      if(isFunction(controller.current?.abort)) {
        controller.current.abort()
      }
      controller.current = null
    }
  }, [apiParam, checkListTime])

  return (
    <div
      className="
        bg-[#FAE5E7] w-full rounded-sm px-4 py-3
        flex items-center justify-between gap-6
      "
    >
      <div className="flex items-center gap-1">
        {
          loading
            ? <CircularProgress size=".8rem" />
            : (
              <span className="bg-[#FF3838] text-white rounded-sm px-1">
                {count}
              </span>
            )
        }
        {ts('newListingNotSeen')}
      </div>
      <div className="flex items-center gap-0.5">
        {ts('view')}
        <ArrowForwardIosIcon sx={{ fontSize: '.7rem' }} />
      </div>
    </div>
  )
}

export function TipsForNewListingsBack() {
  const ts = useTranslations('search')

  return (
    <div 
      className="
        w-full flex items-center shadow-simple p-2 gap-2 
        cursor-pointer w-full
      "
    >
      <SVGBack className="text-primary" />
      {ts('viewAllProperties')}
    </div>
  )
}

export function TipsForNewListingsBody({
  children,
  onClick,
  type,
  param,
  className
}) {
  const locale = useLocale()

  const isClick = isFunction(onClick)
  const Wedget = isClick ? ButtonBase : Link
  const props = isClick 
    ? { onClick: () => onClick({ type, param }) } 
    : { href: urls.listing(type, param, locale) }

  return (
    <Wedget
      {...props}
      className={clsx(['flex w-[23rem] max-w-full', className])}
    >
      {children}
    </Wedget>
  )
}
